export const analyticPalette = {
	primary: {
		lighter: '#dffae8',
		light: '#a2ede6',
		main: '#6aa8dc',
		dark: '#4d57a8',
		darker: '#453172',
		contrastText: '#fff',
	},
	secondary: {
		lighter: '#cfe2cc',
		light: '#66a478',
		main: '#006257',
		dark: '#004e57',
		darker: '#001d41',
		contrastText: '#fff',
	}
}